@if ({
  sending: sending$ | async,
  error: error$ | async
  }; as type) {
  @if (!type.sending) {
    @if (type.error==undefined) {
      @if (component.data$ | async; as data) {
        <div class="registration-confirmation__text"
        [innerHTML]="data.content"></div>
      }
    } @else {
      @if (type.error.status==410) {
        @if (type.error.error.errors[0].type=='RegistrationAlreadyConfirmed') {
          <div class="registration-confirmation__text">
            <strong>{{ 'efaHttpHandlers.registrationAlreadyConfirmed' | cxTranslate }}</strong></div>
            <br/>
            @if (component.data$ | async; as data) {
              <div class="registration-confirmation__text"
              [innerHTML]="data.content"></div>
            }
          }
          @if (type.error.error.errors[0].type=='TokenWasRefreshed') {
            <div class="registration-confirmation__text">
            {{ 'efaRegistrationConfirmation.error' | cxTranslate }}</div>
            <br/>
            <div class="registration-confirmation__text">
              <strong>{{ 'efaHttpHandlers.tokenWasRefreshed' | cxTranslate }}</strong></div>
            }
            @if (type.error.error.errors[0].type=='TokenNotFound') {
              <div class="registration-confirmation__text">
              {{ 'efaRegistrationConfirmation.error' | cxTranslate }}</div>
              <br/>
              <div class="registration-confirmation__text">
                <strong>{{ 'efaHttpHandlers.tokenNotFound' | cxTranslate }}</strong></div>
              }
            } @else {
              <strong>
                <div class="registration-confirmation__text">
                {{ 'efaRegistrationForm.globalMessage.registrationConfirmationFailure' | cxTranslate }}</div>
              </strong>
            }
          }
        } @else {
          @if (type.sending) {
            <div class="cx-spinner">
              <cx-spinner></cx-spinner>
            </div>
          }
        }
      }
